<template>
  <div class="mail-template-header-wrap">
    <nav aria-label="breadcrumb" class="mail-breadcrumb">
      <ol>
        <li>
          <router-link :to="{ name: 'company.mail.templates2' }">
            {{ tt("mail.templates", $t("general.manage_email_templates")) }}
          </router-link>
        </li>
        <li>{{ templateName }}</li>
        <li>{{ tt("general.edit", "Düzenle") }}</li>
      </ol>
    </nav>

    <div class="mail-template-header">
      <div class="mail-template-heading">
        <h1>{{ tt("general.edit_template", "Mail Şablonu Düzenle") }}</h1>
        <p>
          {{
            tt(
                "general.edit_template_subtitle",
                "Mail şablonunuzu düzenleyin ve önizleyin."
            )
          }}
        </p>
      </div>
      <div class="mail-template-actions">
        <button :disabled="disabled"
                class="mail-btn"
                type="button"
                @click="$emit('cancel')"
        >
          {{ $t("general.cancel") }}
        </button>
        <button :disabled="disabled"
                class="mail-btn mail-btn-primary"
                type="button"
                @click="$emit('save')"
        >
          {{ $t("general.save") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MailTemplateHeader",
  props: {
    templateName: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    tt(key, fallback) {
      if (this.$te && this.$te(key)) {
        const translated = this.$t(key);
        if (translated && translated !== key) return translated;
      }
      return fallback;
    },
  },
};
</script>

<style scoped>
.mail-breadcrumb {
  margin: 0 0 14px;
}

.mail-breadcrumb ol {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  color: #a0a5b8;
  font-size: 13px;
  line-height: 1.4;
}

.mail-breadcrumb li {
  display: inline-flex;
  align-items: center;
}

.mail-breadcrumb li:not(:last-child)::after {
  content: ">";
  margin: 0 8px;
  color: #c3c7d6;
  font-size: 12px;
}

.mail-breadcrumb a {
  color: #6d63ff;
  text-decoration: none;
  font-weight: 500;
}

.mail-breadcrumb a:hover {
  color: var(--mail-primary);
}

.mail-template-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 20px;
}

.mail-template-heading h1 {
  margin: 0 0 4px;
  color: var(--mail-text);
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.03em;
  line-height: 1.2;
}

.mail-template-heading p {
  margin: 0;
  color: var(--mail-muted);
  font-size: 14px;
  line-height: 1.45;
}

.mail-template-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  flex-shrink: 0;
  gap: 8px;
  padding-top: 2px;
}

.mail-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid var(--mail-border);
  background: #fff;
  color: #2a2f4a;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
}

.mail-btn i {
  font-size: 15px;
  color: #6a7090;
}

.mail-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.mail-btn-primary {
  background: var(--mail-primary);
  border-color: var(--mail-primary);
  color: #fff;
  min-width: 78px;
  padding: 0 18px;
}

@media (max-width: 1199px) {
  .mail-template-header {
    flex-direction: column;
  }

  .mail-template-actions {
    padding-top: 0;
  }
}

@media (max-width: 767px) {
  .mail-template-header,
  .mail-template-actions {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .mail-template-heading h1 {
    font-size: 24px;
  }

  .mail-btn {
    width: 100%;
  }
}
</style>
